import { Injectable } from '@angular/core';

@Injectable()
export class FunctionFactory{
    public buildFunction(name: string, body: string, context: any) : void{
        context[name] =  new Function(body);
    }

}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/util/function.factory.ts